// Imports
import PlaceUpserter from '../../../shareables/front-end/place-upserter';


// Function component
const Location: React.FC = () => (
	<PlaceUpserter
		presentFields={['countryCode', 'regionID', 'division1', 'division2', 'postalCode']}
		initialPlace={{
			countryCode: 'USA',
		}}
		autoFocus
	/>
);

export default Location;
